<template>
  <div class="wrap">
    <slot class="wrap-bread" name="bread"></slot>
    <div class="wrap-container" :class="{ 'is-bg': isBg }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Wrap",
  props: {
    isBg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  border-radius: 6px;
  flex-direction: column;

  .wrap-container {
    padding: 0px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    &.is-bg {
      background-color: #fff;
      padding: 20px;
    }
  }
}
</style>
